import * as React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-bootstrap";
import "./OurNumbers.scss";
import CallToAction from "../CallToAction/CallToAction";
import query from "./query";
import Item from "./Item/Item";
import Animation from "./Animation/Animation";
import { useState } from "react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import {
  filterDataByLanguage,
  filterListDataByLanguage,
} from "../../Utils/Language";
import Lottie from "react-lottie";
import * as LottieAnimation from "./Animation/data.json";

const OurNumbers = (props) => {
  const data = query();
  const ourNumbersData = filterDataByLanguage(
    props.lang,
    data.allContentfulOurNumbers
  );
  const itemsData = filterListDataByLanguage(
    props.lang,
    data.allContentfulOurNumbersItem
  );

  const [animationCompleted, setAnimationCompleted] = useState(false, false);

  return (
    <div>
      <div className="our-numbers-container">
        <Container fluid>
          <Row className="our-numbers-main-title-row pb-lg-5">
            <Col>
              <p className="our-numbers-main-title">
                {ourNumbersData.mainTitle.mainTitle}
              </p>
              <p className="our-numbers-main-title green">
                {ourNumbersData.mainSubtitle.mainSubtitle}
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      <RenderAnimation
        setAnimationCompleted={setAnimationCompleted}
        data={ourNumbersData}
      />

      {(animationCompleted || isMobile()) && (
        <div className="our-numbers-container">
          <Container className="pt-lg-5">
            <Row className="pt-lg-5 pb-lg-5 pt-5 pb-5">
              <Col className="col-lg-12 col-12 pt-lg-5 our-numbers-title">
                {ourNumbersData.title.title}
              </Col>
            </Row>

            {itemsData && <Item itemsData={itemsData} />}

            <Row className="pt-lg-5 pt-0 our-numbers-info-row">
              <Col className="col-lg-12"> </Col>
            </Row>
          </Container>
        </div>
      )}
      {(animationCompleted || isMobile()) && (
        <div>
          <div className="our-numbers-footer text-lg-end text-center">
            <div className="our-numbers-footer-row">
              <RenderImage data={ourNumbersData} />
            </div>
          </div>
          {/*)}*/}
          {/*{(animationCompleted || isMobile()) && (*/}
          <div className="our-numbers-footer">
            <Container fluid>
              <Row className="pt-lg-4 pb-lg-5 pt-2 pb-2">
                <Col className="col-lg-6 col-12 pb-4"> </Col>
                <Col className="col-lg-6 col-12 pb-4 our-numbers-info-description footer-description">
                  <p>{ourNumbersData.description.description}</p>
                </Col>
              </Row>
              <Row className="our-numbers-call-to-action">
                <Col className="col-lg-6 col-12"> </Col>
                <Col className="col-lg-6 col-12">
                  <CallToAction
                    to={ourNumbersData.link}
                    label={ourNumbersData.linkText}
                  />
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      )}
    </div>
  );
};

// Manage type of animation (GSAP Desktop, Lottie Mobile)
function RenderAnimation(props) {
  if (typeof window === "undefined") {
    return null;
  }

  if (window.innerWidth >= 1440) {
    return (
      <Animation
        setAnimationCompleted={props.setAnimationCompleted}
        data={props.data}
      />
    );
  } else {
    const defaultOptions = {
      loop: false,
      autoplay: true,
      animationData: LottieAnimation,
      rendererSettings: {
        preserveAspectRatio: "xMidYMin slice",
      },
    };

    return <Lottie options={defaultOptions} height="100%" width="100%" />;
  }
}

function isMobile() {
  if (typeof window === "undefined") {
    return null;
  }
  return window.innerWidth < 1440;
}

function RenderImage(props) {
  if (typeof window === "undefined") {
    return null;
  }

  if (window.innerWidth < 959) {
    return (
      <GatsbyImage
        className="our-numbers-image img-fluid"
        alt={props.data.ourNumbersImageSmall.title}
        image={getImage(props.data.ourNumbersImageSmall)}
      />
    );
  } else {
    return (
      <GatsbyImage
        className="our-numbers-image"
        alt={props.data.ourNumbersImageLarge.title}
        image={getImage(props.data.ourNumbersImageLarge)}
      />
    );
  }
}

OurNumbers.propTypes = {
  lang: PropTypes.string.isRequired,
};

RenderImage.propTypes = {
  data: PropTypes.object,
};

RenderAnimation.propTypes = {
  setAnimationCompleted: PropTypes.bool,
  data: PropTypes.object.isRequired,
};

export default OurNumbers;
